import { Injectable, computed, inject, effect } from '@angular/core';
import { HuntStateService } from './hunt-state.service';
import { Enums } from '@cyborg-monorepo/hunter/common';
import { Router, ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { defer } from 'rxjs';
import { findRouteWithParam } from '../helpers/utils';
@Injectable({ providedIn: 'root' })
export class QueryActiveHuntService {
  private readonly huntState = inject(HuntStateService);
  private readonly router = inject(Router);
  
  // Grab huntId from route lazily
  readonly huntId = toSignal(
    defer(() => {
      const routeWithId = findRouteWithParam(this.router.routerState.root, 'id');
      return (routeWithId?.paramMap ?? this.router.routerState.root.paramMap).pipe(
        map(params => params.get('id'))
      );
    }),
    { initialValue: null }
  );
        
  // Full hunt object
  readonly hunt = computed(() => this.huntState.hunt());

  // ✅ Active Hunt from URL (matched against state)
  readonly activeHunt = computed(() => {
    const id = this.huntId();
    const hunt = this.hunt();
    return hunt?.id === id ? hunt : null;
  });

  // === Normalized huntPackages list ===
  readonly huntPackages = computed(() => this.activeHunt()?.huntPackages ?? []);

  // === Global hunt status (non-package-level) ===
  readonly isComplete = computed(() =>
    this.activeHunt()?.status === Enums.StatusEnum.DONE
  );

    // === If a hunt has an associated template or not ===
    readonly hasHuntTemplate = computed(() =>
      this.hunt()?.huntTemplate !== null
    );
  // === Convenience accessors ===
  readonly name = computed(() => this.activeHunt()?.name ?? 'Untitled Hunt');
  readonly createdDate = computed(() => this.activeHunt()?.created ?? 'N/A');
  readonly author = computed(() => {
    const author = this.activeHunt()?.author;
    if (!author) return 'Unknown';
    return `${author.firstName} ${author.lastName}`;
  });
  readonly priority = computed(() => this.activeHunt()?.priority ?? 'Unknown');
  readonly status = computed(() => this.activeHunt()?.status ?? 'Unknown');
  readonly hypothesis = computed(() => this.activeHunt()?.hypothesis ?? '');

  constructor() {
    effect(() => {
      const active = this.activeHunt();
      console.log('🐛 Debug: hunt loaded?', !!active);
      console.log('🐛 Active Hunt: ', this.activeHunt());
      // console.log('📦 Active Hunt: Environments', active?.environments ?? []);
        });
  }

}